import { Card, CardHeader } from "@mui/material";
import type { Mission } from "@rescuetablet/missions-client";
import { useOutletContext } from "react-router";
import PatientsTable from "./PatientsTable";

export default function PatientListPage() {
  const {
    mission: { patients },
  } = useOutletContext<{ mission: Mission }>();

  return patients.length ? (
    <Card>
      <CardHeader title="In diesem Einsatz erfasste Patienten" />
      <PatientsTable patients={patients} />
    </Card>
  ) : null;
}
